/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import dates from '../images/og.png'
import { useLocale } from './Lang'

function SEO({ description, meta, title }) {
  const lang = useLocale()

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            domain
            description {
              fr
              en
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description[lang]
  const pageTitle = title || site.siteMetadata.title
  const domain = site.siteMetadata.domain

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={pageTitle}
      titleTemplate={pageTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: pageTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: domain,
        },
        {
          property: `og:image`,
          content: `${domain}${dates}`,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
